<template>
  <FormItemWrapper>
    <FormItemLabel slot="label">
      {{ $t('formItemLabelMeterType') }}
    </FormItemLabel>
    <Tooltip
      v-if="$t('formItemTooltipMeterType')"
      slot="tooltip"
      :content="$t('formItemTooltipMeterType')"
    />
    <el-radio-group v-model="meterType">
      <el-radio
        v-for="(item, index) in meterTypes"
        :key="`item-${index}`"
        :label="item.value"
      >
        {{ item.label }}
      </el-radio>
    </el-radio-group>
  </FormItemWrapper>
</template>

<script>
import Vue from 'vue';
import { Radio, RadioGroup } from 'element-ui';
import FormItemWrapper from '@/components/formItem/Wrapper.vue';
import FormItemLabel from '@/components/formItem/Label.vue';
import Tooltip from '@/components/Tooltip.vue';

Vue.use(Radio);
Vue.use(RadioGroup);

export default {
  name: 'FilterMeterType',
  components: {
    FormItemWrapper,
    FormItemLabel,
    Tooltip,
  },
  computed: {
    meterTypes() {
      return [
        {
          value: 'single_rate_meter',
          label: this.$t('formItemMeterTypeTextValueSingleMeter'),
        },
        {
          value: 'double_rate_meter',
          label: this.$t('formItemMeterTypeTextValueDoubleMeter'),
        },
      ];
    },
    meterType: {
      get() {
        return this.$store.state.filter.activeFilters.meterType;
      },
      set(value) {
        this.$store.commit('filter/SET_METER_TYPE', value);
      },
    },
  },
};
</script>
